(function () {
  const storyteqForm = document.querySelector('.js-storyteq-form');
  if (!storyteqForm) return;
  
  const requiredInputs = storyteqForm.querySelectorAll('[required]');
  
  function isValid(el) {
    if (el.type === 'email') {
      const isValidEmail = /^\S+@\S+\.\S+$/.test(el.value);
      return el.value && isValidEmail;
    }
    return Boolean(el.value);
  }
  
  const hasInvalidClass = formFieldEl => formFieldEl.classList.contains('form-field-invalid');
  const showAsInvalid = formFieldEl => formFieldEl.classList.add('form-field-invalid');
  const showAsValid = formFieldEl => formFieldEl.classList.remove('form-field-invalid');
  
  storyteqForm.addEventListener('submit', (e) => {
    let hasInvalidInputs = false;
    
    [].forEach.call(requiredInputs, inputEl => {
      const formFieldEl = inputEl.closest('.form-field');
      if (isValid(inputEl)) {
        showAsValid(formFieldEl);
      } else {
        showAsInvalid(formFieldEl);
        hasInvalidInputs = true;
      }
    })
    
    if (hasInvalidInputs) {
      e.preventDefault();
    }
  });
  
  [].forEach.call(requiredInputs, input => {
    // Remove the error when invalid input changes into a valid input by changing the value
    input.addEventListener('input', () => {
      const formFieldEl = input.closest('.form-field');
      const wasInvalid = hasInvalidClass(formFieldEl);
      if (wasInvalid && isValid(input)) {
        showAsValid(formFieldEl);
      }
    })
  });
})()